import { render, staticRenderFns } from "./mudarTurma.vue?vue&type=template&id=29a2a291&"
import script from "./mudarTurma.vue?vue&type=script&lang=js&"
export * from "./mudarTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports